var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class BaseLogger {
  constructor(context, getLogger) {
    __publicField(this, "loggerContext");
    __publicField(this, "getLogger");
    this.loggerContext = context;
    this.getLogger = getLogger;
    this.setContext = this.setContext.bind(this);
    this.log = this.log.bind(this);
    this.debug = this.debug.bind(this);
    this.info = this.info.bind(this);
    this.warn = this.warn.bind(this);
    this.error = this.error.bind(this);
  }
  log({
    level: type,
    message,
    messageContext,
    customProperties = [],
    error
  }) {
    const overrideMessageContext = {
      ...this.loggerContext,
      ...messageContext,
      module: messageContext.module || this.loggerContext.module,
      codeOwners: messageContext.codeOwners || this.loggerContext.codeOwners
    };
    this.getLogger()[type](
      message,
      overrideMessageContext,
      customProperties,
      error
    );
  }
  debug(message, messageContext, customProperties) {
    this.log({
      level: "debug",
      message,
      messageContext,
      customProperties
    });
  }
  info(message, messageContext, customProperties) {
    this.log({
      level: "info",
      message,
      messageContext,
      customProperties
    });
  }
  warn(message, messageContext, customProperties) {
    this.log({
      level: "warn",
      message,
      messageContext,
      customProperties
    });
  }
  error(message, messageContext, customProperties, error) {
    this.log({
      level: "error",
      message,
      messageContext,
      customProperties,
      error
    });
  }
  /**
   * Defines context for all log messages
   * @deprecated This method is deprecated. Please provide the context in the IModuleConfig interface or override the context in the log method
   * @param context IDataDogContext
   */
  setContext(context) {
    console.warn(
      "setContext is deprecated. Please provide the context in the IModuleConfig interface or override the context in the log method",
      context
    );
  }
}
class ShellLogger extends BaseLogger {
  constructor(context, getLogger) {
    super(context, getLogger);
    this.setUserData = this.setUserData.bind(this);
    this.unsetUserData = this.unsetUserData.bind(this);
    this.setHandlerType = this.setHandlerType.bind(this);
  }
  setUserData(userId, userEmail) {
    this.getLogger().setUserData(userId, userEmail);
  }
  unsetUserData() {
    this.getLogger().unsetUserData();
  }
  setHandlerType(handlerType) {
    this.getLogger().setHandlerType(handlerType);
  }
}
class MicroFrontendLogger extends BaseLogger {
  constructor(context, getLogger) {
    super(context, getLogger);
  }
  /**
   * Defines user data for all log messages
   * @deprecated This method is deprecated. Shell will provide user data automatically
   * @param userId user ID
   * @param userEmail user email
   */
  setUserData(userId, userEmail) {
    console.warn(
      "setUserData is deprecated. Shell will provide user data automatically"
    );
  }
  /**
   * Removes user data from all log messages
   * @deprecated This method is deprecated. Shell will unset user data automatically
   */
  unsetUserData() {
    console.warn(
      "unsetUserData is deprecated. Shell will unset user data automatically"
    );
  }
}
export {
  MicroFrontendLogger,
  ShellLogger
};
